(function(Download, $, undefined) {
  var bindUIActions = function() {
    $(document).on('click', '[data-download]', function(e){
      e.preventDefault();
      var downloadUrl = $(this).attr('data-download');
      console.log(downloadUrl)

      if (downloadUrl.indexOf(',') > -1) {
        const downloads = downloadUrl.slice(0, -1).split(',');

        for (let i = 0; i < downloads.length; i++) {
          download(downloads[i]);
        }
      } else {
        download(downloadUrl);
      }
    });    
  }

  Download.init = function() {
    bindUIActions(); 
  }

}(window.Download = window.Download || {}, jQuery));